import { useState, useEffect, useRef } from "react";
import { Slider } from "@mui/material";
import TLIconOff from "assets/images/TL_off.png";
import shareIconOff from "assets/images/share_off.png";
import { useFaal, useSharedFaalUrl } from "hooks/faal";
import useInputKeys from "hooks/useInputKeys";
import "./index.scss";
import { useTheme } from "@emotion/react";
import { useThemeContext } from "theme/ThemeContextProvider";
import Perpule from "assets/images/perpule-neat.png";
import Cyan from "assets/images/cyan-neat.png";
import Green from "assets/images/green-neat.png";
import Pink from "assets/images/pink-neat.png";
import LightCyan from "assets/images/lightCyan-neat.png";
import LightGreen from "assets/images/lightGreen-neat.png";


function Faal({ active, sharedFaalId }) {
  const [showButton, setShowButton] = useState(false);
  const [showFal, setShowFal] = useState(!!sharedFaalId);
  const [trackTime, setTrackTime] = useState(false);
  const [trackStatus, setTrackStatus] = useState(
    sharedFaalId ? "paused" : "played"
  );
  const { setSharedFaalId } = useInputKeys();
  const [faalData, setFaalData] = useState({});
  const { mutate: getFaal } = useFaal();
  const { mutate: getSharedFaalUrl } = useSharedFaalUrl();
  const faalTrackPlayer = useRef(null);
  const theme = useTheme();
  const {mode} = useThemeContext();

  useEffect(() => {
    if (sharedFaalId) {
      getSharedFaalUrl(sharedFaalId, {
        onSuccess: (response) => {
          if (response.status === "OK") {
            setFaalData(response);
          }
        },
        onError: (error) => {
          console.log(error);
          setSharedFaalId("");
        },
      });
    }
  }, [getSharedFaalUrl, sharedFaalId, setSharedFaalId]);

  const getImageActiveHref = () => {
    return mode === 'light' ? Perpule
         : mode === 'Cyan' ? Cyan
         : mode === 'Green' ? Green
         : mode === 'Pink' ? Pink
         : mode === 'LightCyan' ? LightCyan
         : mode === 'LightGreen' ? LightGreen
         : '';
  };

  useEffect(() => {
    if (!active) {
      setShowButton(false);
      setShowFal(false);
    }
    if (active && !sharedFaalId) {
      const timer = setTimeout(() => {
        setShowButton(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [active, sharedFaalId]);

  const handleFaal = () => {
    getFaal(
      {},
      {
        onSuccess: (response) => {
          if (response.status === "OK") {
            setFaalData(response);
            setShowFal(true);
          }
        },
        onError: (error) => {
          console.log(error);
        },
      }
    );
  };

  const handleTimeUpdate = () => {
    setTrackTime(faalTrackPlayer.current.currentTime);
  };

  const handlePlay = () => {
    faalTrackPlayer.current.play();
    setTrackStatus("played");
  };
  const handlePause = () => {
    faalTrackPlayer.current.pause();
    setTrackStatus("paused");
  };
  const handleRepeat = () => {
    faalTrackPlayer.current.play();
    setTrackStatus("played");
  };

  const handleShare = () => {
    let currentUrl = document.location.href;
    if (navigator.share) {
      navigator
        .share({
          title: "فال تایم لاین",
          text: "ببین چه فالی اومده!",
          url: `${currentUrl}faal?fid=${faalData?.fId}`,
        })
        .then(() => console.log("Successful share"))
        .catch((error) => console.log("Error sharing", error));
    } else if (navigator.clipboard) {
      let sharingText = `${currentUrl}faal?fid=${faalData?.fId}\n\n ببین چه فالی اومده!`;
      navigator.clipboard.writeText(sharingText);
    }
  };

  return (
    <>
      {showFal ? (
        <div className="parent-music-player-top">
          <div
            className="music-player-top"
            style={{ width: "100%", height: "100%" }}
          >
            <img style={{ width: "5%" }} src={TLIconOff} alt="" />
            {navigator.share || navigator.clipboard ? (
              // <img
              //   style={{ width: "5%" }}
              //   src={shareIconOn}
              //   onClick={handleShare}
              //   alt=""
              // />
              <svg
                width="67"
                height="77"
                viewBox="0 0 67 77"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ width: "5%", cursor: "pointer" }}
                onClick={handleShare}
              >
                <path
                  d="M56.8999 18.71C61.9864 18.71 66.1099 14.5866 66.1099 9.50003C66.1099 4.41349 61.9864 0.290039 56.8999 0.290039C51.8134 0.290039 47.6899 4.41349 47.6899 9.50003C47.6899 14.5866 51.8134 18.71 56.8999 18.71Z"
                  fill={theme.palette.primary.main}
                />
                <path
                  d="M9.23999 47.38C14.3265 47.38 18.45 43.2565 18.45 38.17C18.45 33.0834 14.3265 28.96 9.23999 28.96C4.15345 28.96 0.0300293 33.0834 0.0300293 38.17C0.0300293 43.2565 4.15345 47.38 9.23999 47.38Z"
                  fill={theme.palette.primary.main}
                />
                <path
                  d="M56.8999 76.0602C61.9864 76.0602 66.1099 71.9367 66.1099 66.8502C66.1099 61.7636 61.9864 57.6401 56.8999 57.6401C51.8134 57.6401 47.6899 61.7636 47.6899 66.8502C47.6899 71.9367 51.8134 76.0602 56.8999 76.0602Z"
                  fill={theme.palette.primary.main}
                />
                <path
                  d="M56.9 9.5L9.23999 38.17"
                  stroke={theme.palette.primary.main}
                  stroke-width="5"
                  stroke-miterlimit="10"
                />
                <path
                  d="M56.9 66.8499L9.23999 38.1699"
                  stroke={theme.palette.primary.main}
                  stroke-width="5"
                  stroke-miterlimit="10"
                />
              </svg>
            ) : (
              <img style={{ width: "5%" }} src={shareIconOff} alt="" />
            )}
            <audio
              autoPlay={!sharedFaalId}
              ref={faalTrackPlayer}
              src={faalData?.url}
              onTimeUpdate={handleTimeUpdate}
              onEnded={() => setTrackStatus("ended")}
            />
            <Slider
              aria-label="time-indicator"
              size="medium"
              value={+trackTime}
              min={0}
              // step={1}
              max={faalData?.metadata?.duration}
              // onChange={(_, value) => setPosition(value)}
              color={theme.palette.primary.main}
              sx={{
                width: "60%",
                color: theme.palette.primary.main,
                cursor: "context-menu",
                height: 4,
                "& .MuiSlider-thumb": {
                  width: 0,
                  height: 0,
                  transition: "0.3s cubic-bezier(.47,1.64,.41,.8)",

                  "&::before": {
                    boxShadow: "0 2px 12px 0 rgba(0,0,0,0.4)",
                    display: "none",
                  },
                  "&:hover, &.Mui-focusVisible": {
                    display: "none",
                  },
                  "&.Mui-active": {
                    display: "none",
                  },
                },
                "& .MuiSlider-rail": {
                  opacity: 0.28,
                },
              }}
            />
            {trackStatus === "played" ? (
              <svg
                width="30"
                height="39"
                viewBox="0 0 30 39"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={handlePause}
                className="playImg"
              >
                <path
                  d="M26.0002 4L26.0002 35"
                  stroke={theme.palette.primary.main}
                  stroke-width="8"
                  stroke-linecap="round"
                />
                <path
                  d="M4.00024 4L4.00024 35"
                  stroke={theme.palette.primary.main}
                  stroke-width="8"
                  stroke-linecap="round"
                />
              </svg>
            ) : trackStatus === "paused" ? (
              <svg
                width="43"
                height="48"
                viewBox="0 0 43 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={handlePlay}
                className="playImg"
              >
                <path
                  d="M41.1501 22.65L2.84007 0.529979C2.60973 0.399302 2.34925 0.331068 2.08443 0.332042C1.81961 0.333015 1.55964 0.403166 1.33028 0.535533C1.10091 0.667899 0.910102 0.857877 0.77676 1.08668C0.643419 1.31548 0.572169 1.57516 0.570068 1.83998V46.08C0.572169 46.3448 0.643419 46.6045 0.77676 46.8333C0.910102 47.0621 1.10091 47.2521 1.33028 47.3844C1.55964 47.5168 1.81961 47.5869 2.08443 47.5879C2.34925 47.5889 2.60973 47.5207 2.84007 47.39L41.1501 25.27C41.3807 25.1378 41.5723 24.947 41.7056 24.717C41.8389 24.487 41.9091 24.2258 41.9091 23.96C41.9091 23.6941 41.8389 23.433 41.7056 23.203C41.5723 22.973 41.3807 22.7822 41.1501 22.65Z"
                  fill={theme.palette.primary.main}
                  stroke={theme.palette.primary.main}
                  stroke-width="0.5"
                  stroke-miterlimit="10"
                />
              </svg>
            ) : (
              <svg
                width="54"
                height="39"
                viewBox="0 0 54 39"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="playImg"
                onClick={handleRepeat}
              >
                <path
                  d="M40.3333 29.6667H16.3333C11.8889 29.6667 3 27 3 16.3333C3 5.66667 11.8889 3 16.3333 3H37.6667C42.1112 3 51 5.66667 51 16.3333C51 20.3181 49.7595 23.1867 47.9733 25.2165"
                  stroke={theme.palette.primary.main}
                  stroke-width="5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M33.667 23L40.3337 29.6667L33.667 36.3333"
                  stroke={theme.palette.primary.main}
                  stroke-width="5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            )}
          </div>
        </div>
      ) : (
        <>
          <div className="faal-box">
            <div className="neat-text">
            <img src={ getImageActiveHref()} alt="neat"/>
            </div>
            <div
              className={`neat-faal-button ${
                showButton ? "" : "hideButtonFaal"
              }`}
            >
              <svg
                width="511"
                height="101"
                viewBox="0 0 511 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={() => {
                  handleFaal();
                }}
              >
                <path
                  d="M259.195 21.1016C259.336 20.8828 259.453 20.7891 259.547 20.8203C259.641 20.8359 259.688 21.0391 259.688 21.4297C259.609 21.8516 259.539 22.4531 259.477 23.2344C259.414 24 259.352 24.8828 259.289 25.8828C259.242 26.8828 259.195 27.9609 259.148 29.1172C259.102 30.2578 259.055 31.4219 259.008 32.6094C258.961 33.7969 258.914 34.9688 258.867 36.125C258.82 37.2812 258.773 38.3516 258.727 39.3359C258.539 44.1172 258.391 47.2109 258.281 48.6172C258.203 49.4609 258.102 50.2891 257.977 51.1016C257.477 55.1328 256.586 58.7969 255.305 62.0938C254.273 64.7188 252.953 67.1797 251.344 69.4766C247.547 74.6172 242.984 77.1797 237.656 77.1641C235.109 77.0547 232.961 76.1797 231.211 74.5391C229.43 72.8984 228.492 70.5781 228.398 67.5781C228.383 62.7969 229.852 57.5547 232.805 51.8516L233.695 50.1172C233.805 50.0859 233.844 50.2734 233.812 50.6797C233.781 51.0859 233.609 51.6562 233.297 52.3906C232.938 53.2656 232.578 54.1562 232.219 55.0625C231.875 55.9531 231.57 56.8438 231.305 57.7344C231.039 58.6094 230.828 59.4766 230.672 60.3359C230.531 61.1797 230.484 61.9922 230.531 62.7734C230.844 65.1172 231.844 66.8359 233.531 67.9297C235.234 69.0391 237.219 69.6328 239.484 69.7109C242.531 69.7422 245.461 68.9453 248.273 67.3203C250.367 65.9297 252.031 64.1875 253.266 62.0938C254.672 59.8906 255.508 56.2812 255.773 51.2656C255.836 50.5 255.867 49.6406 255.867 48.6875C255.977 46.1406 256.055 43.6328 256.102 41.1641C256.148 38.6953 256.203 36.25 256.266 33.8281C256.344 31.4062 256.461 29.8047 256.617 29.0234C256.789 28.2422 256.961 27.5781 257.133 27.0312L259.195 21.1016ZM263.719 51.6406C263.719 52.4219 263.812 53.1484 264 53.8203C264.203 54.4922 264.5 55.0781 264.891 55.5781C265.281 56.0781 265.758 56.4922 266.32 56.8203C266.898 57.1328 267.562 57.3359 268.312 57.4297C271.172 57.5859 273.109 56.6719 274.125 54.6875C274.172 54.5938 274.172 54.4922 274.125 54.3828C273.906 53.9922 273.656 53.7031 273.375 53.5156C273.047 53.2969 272.734 53.2734 272.438 53.4453C272.234 53.5859 271.961 53.7109 271.617 53.8203C271.289 53.9141 270.953 53.9609 270.609 53.9609C270.172 53.9609 269.727 53.8516 269.273 53.6328C268.836 53.4141 268.508 53.0781 268.289 52.625C268.102 52.2812 268.086 51.8438 268.242 51.3125C268.414 50.7812 268.734 50.0391 269.203 49.0859C269.672 48.1172 270.18 47.1641 270.727 46.2266C271.273 45.2734 271.898 44.7969 272.602 44.7969C273.523 44.7969 274.453 45.3203 275.391 46.3672C276.328 47.3984 276.773 48.7344 276.727 50.375C276.727 51.9219 276.328 53.7734 275.531 55.9297C274.75 58.0859 273.789 59.8906 272.648 61.3438C271.914 62.2344 271.266 62.9219 270.703 63.4062C269.469 64.4688 268.016 65 266.344 65C264.359 65 262.906 64.2656 261.984 62.7969C261.078 61.3125 260.648 59.5078 260.695 57.3828C260.695 56.7891 260.883 54.9453 261.258 51.8516C261.648 48.7578 261.938 46.5469 262.125 45.2188C262.328 43.875 262.555 42.4531 262.805 40.9531C263.055 39.4531 263.297 38.2422 263.531 37.3203C263.797 36.5547 264.078 35.7812 264.375 35C264.688 34.2188 265.008 33.4453 265.336 32.6797C265.555 32.3359 265.695 32.3906 265.758 32.8438C265.367 35.4375 265.008 38.1328 264.68 40.9297C264.352 43.7109 264.125 45.7031 264 46.9062C263.891 48.1094 263.836 48.8125 263.836 49.0156C263.758 50.2188 263.719 51.0938 263.719 51.6406ZM277.031 27.7812C277.156 28.2344 277.148 28.7031 277.008 29.1875C276.883 29.6719 276.641 30.1797 276.281 30.7109C276.062 31.0703 275.828 31.3984 275.578 31.6953C275.344 31.9766 275.094 32.25 274.828 32.5156C274.75 32.6094 274.625 32.7266 274.453 32.8672C274.281 33.0078 274.102 33.1406 273.914 33.2656C273.727 33.3906 273.547 33.4844 273.375 33.5469C273.203 33.5938 273.078 33.5703 273 33.4766C272.438 33.0234 271.883 32.5625 271.336 32.0938C270.789 31.625 270.188 31.1875 269.531 30.7812C269.422 30.7031 269.367 30.6328 269.367 30.5703C269.383 30.4922 269.43 30.3828 269.508 30.2422L273.258 24.5234C273.367 24.3672 273.477 24.2969 273.586 24.3125C273.695 24.3125 273.812 24.3516 273.938 24.4297C274.266 24.6172 274.594 24.8281 274.922 25.0625C275.25 25.2969 275.555 25.5547 275.836 25.8359C276.117 26.1016 276.359 26.3984 276.562 26.7266C276.781 27.0391 276.938 27.3906 277.031 27.7812Z"
                  fill="white"
                />
                <rect
                  x="2"
                  y="2"
                  width="507"
                  height="97"
                  rx="7"
                  fill="url(#paint0_linear_1069_3765)"
                  stroke={theme.palette.primary.main}
                  stroke-width="3"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_1069_3765"
                    x1="255.5"
                    y1="2"
                    x2="255.5"
                    y2="99"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.5" stop-opacity="0" />
                    <stop
                      offset="1"
                      stop-color={theme.palette.primary.main}
                      stop-opacity="0.3"
                    />
                  </linearGradient>
                </defs>
              </svg>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Faal;
